/**
 * Seeded role ids, mirroring Emeis.Shared.Util.RightsUtil on the backend.
 *
 * Role display names are editable — both in the Roles screen and by the
 * seeder — so anything that gates behaviour on a role matches on these ids.
 * A gate that compared display names silently opened up the moment the names
 * were normalised, which is exactly the failure this file exists to prevent.
 */

/** RightsUtil.SuperAdmin — cross-organisation administrator. */
export const SUPER_ADMIN_ROLE_ID = "20689320-6466-43dc-ade7-a64eb76f40e3";

/** RightsUtil.GroupLeader — this organisation's admin ("Org Admin"). */
export const GROUP_ADMIN_ROLE_ID = "b2922c7e-392d-11eb-9b5c-00ffba546a08";

/** RightsUtil.DeptAdmin — scoped to their own department. */
export const DEPT_ADMIN_ROLE_ID = "77777777-3333-7777-7777-777777777777";

/** RightsUtil.BuHead — scoped to every department under their business unit. */
export const BU_HEAD_ROLE_ID = "99999999-1111-9999-9999-999999999999";

/** RightsUtil.Initiator — raises contracts on the organisation's behalf. */
export const INITIATOR_ROLE_ID = "44444444-4444-4444-4444-444444444444";

/** RightsUtil.Eiditor (sic, matching the backend constant) — drafts contract terms. */
export const EDITOR_ROLE_ID = "55555555-5555-5555-5555-555555555555";
